module.exports = __webpack_public_path__ + "img/16581289_L.1a49e6d4.png";